import { PendingContributionsService } from '@festina/moneyin-general-types/moneyin/services/PendingContributionsService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

const method =
  PendingContributionsService.pendingContributionsServicePostMoveToExternalHandling
type MethodParam = Parameters<typeof method>[0]

export const useSubmitMoveToExternalHandling = ({
  tenantId,
}: {
  tenantId: string
}) =>
  useFestinaMutation({
    component: 'moneyIn',
    isScenario: false,
    roles:
      PendingContributionsService.pendingContributionsServicePostMoveToExternalHandling_roles,
    mutateFunction: async (arg: Except<MethodParam, 'xTenantId'>) => {
      await method({
        xTenantId: tenantId,
        ...arg,
      })
    },
  })
